module.exports = __webpack_public_path__ + "check.svg";